import { CoinIcon } from "./coin-icon";

const shieldColors = {
  'gray': {
    '400': '#9ca3af',
    '600': '#4b5563',
  },
  'emerald': {
    '400': '#34d399',
    '600': '#059669',
  },
  'yellow': {
    '400': '#facc15',
    '600': '#ca8a04',
  },
  'sky': {
    '400': '#38bdf8',
    '600': '#0284c7',
  }
}

const defaultColor1 = shieldColors.gray[400];
const defaultColor2 = shieldColors.gray[600];

export const ShieldIcon: React.FC<{h?:number, color1:string, color2:string}> = ({h=24, color1=defaultColor1, color2=defaultColor2}) => {
  return (
    <svg width={h} height={h} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M22.0002 2C17.3335 0 12.0002 0 12.0002 0C12.0002 0 6.66683 0 2.00016 2C0.000161171 12 2.00016 20.6667 12.0002 24C22.0002 20.6667 24.0002 12 22.0002 2Z" fill="#CCD6DD"/>
      <path d="M11.9998 22.5893C4.2745 19.8193 1.30717 13.2206 3.17317 2.96265C7.37517 1.35265 11.9518 1.33331 11.9998 1.33331C12.0472 1.33331 16.6385 1.35998 20.8265 2.96265C22.6925 13.2206 19.7252 19.8193 11.9998 22.5893Z" fill={color1}/>
      <path d="M20.8267 2.96265C16.6387 1.35998 12.0473 1.33331 12 1.33331V22.5893C19.7253 19.8193 22.6927 13.2206 20.8267 2.96265Z" fill={color2}/>
    </svg>
  );
}

interface ShieldPowerUpIconProps {
  code: string,
  size?: number,
  quantity?: number
}

const ShieldPowerUpIcon: React.FC<ShieldPowerUpIconProps> = ({code, size=24, quantity=0}) => {

  let color1;
  let color2;

  switch (code) {
    case 'shield_x_1':
      color1 = shieldColors.sky[400];
      color2 = shieldColors.sky[600];
      break;
    case 'shield_x_2':
      color1 = shieldColors.gray[400];
      color2 = shieldColors.gray[600];
      break;
    case 'shield_x_3':
      color1 = shieldColors.yellow[400];
      color2 = shieldColors.yellow[600];
      break;
    // case 'shield_x_4':
    //   color1 = shieldColors.emerald[400];
    //   color2 = shieldColors.emerald[600];
    //   break;
    default:
      color1 = defaultColor1;
      color2 = defaultColor2;
      break;
  }

  return (
    <div className="relative">

      <div className={`${quantity > 0 ? 'visible' : 'hidden'} absolute top-0 right-0 -translate-y-1 translate-x-1 min-w-4 h-4 bg-black rounded-full flex flex-col justify-center items-center`}>
        <p className="text-white text-xxxxs self-stretch text-center">
          {quantity}
        </p>
      </div>

      <ShieldIcon color1={color1} color2={color2} h={size} />

    </div>
  );
}

export default ShieldPowerUpIcon;